import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Eyebrow from "Root/profile/components/common/Eyebrow";
import H2Font from "Root/profile/components/common/H2Font";
import Checkmark from "Images/quiz/tier/Checkmark.svg";
import styles from "./styles.module.scss";
import RegFont from "Root/profile/components/common/RegFont";
import RoundedGainfulButton from "Root/profile/components/common/RoundedGainfulButton";
import { useHistory } from "react-router";
import mary_preview from "../TargetBanner/images/mary_preview.jpg";
const guidancePoints = [
    "How and when to take your Gainful Products",
    "Curated articles and video content picked for you",
    "Access to our Macronutrient Calculator",
    "Delicious protein-packed recipes",
    "Direct access to our full-time Registered Dietitians",
];
const TargetPreview = () => {
    const history = useHistory();
    const getStarted = () => {
        history.push("/quiz-start-target/");
    };
    return (_jsxs("div", { className: styles.preview, children: [_jsx("div", { className: styles.video, children: _jsx("video", { src: "https://dlye1hka1kz5z.cloudfront.net/site/video/target_rd.mp4", preload: "metadata", controls: true, loop: false, controlsList: "", playsInline: true, poster: mary_preview, children: _jsx("track", { src: "https://dlye1hka1kz5z.cloudfront.net/site/video/target_rd.vtt", kind: "captions", srcLang: "en", label: "english_captions" }) }) }), _jsxs("div", { className: styles.guidence, children: [_jsx(Eyebrow, { children: "What we provide" }), _jsx(H2Font, { children: "Personalized Guidance, Fueled by Gainful's Registered Dietitians" }), _jsx("div", { className: styles.points, children: guidancePoints.map((item) => (_jsxs("div", { className: styles.point, children: [_jsx("img", { src: Checkmark, alt: "checkmark" }), " ", _jsx(RegFont, { children: item })] }, item))) }), _jsx("div", { className: styles.get_started, children: _jsx(RoundedGainfulButton, { onClick: getStarted, label: "Get Started" }) })] })] }));
};
export default TargetPreview;
